import { Controller } from "@hotwired/stimulus";

var StaffContactsFilterController = class extends Controller {
  filter() {
    var hubCompany = this.hubCompanyFilterTarget.value;
    var admin = this.adminFilterTarget.value;
    var appEvent = this.appEventFilterTarget.value;
    var visibleCount = 0;

    this.rowTargets.forEach((row) => {
      var matches =
        (!hubCompany || row.dataset.hubCompanyId === hubCompany) &&
        (!admin || row.dataset.adminId === admin) &&
        (!appEvent || row.dataset.appEventId === appEvent);

      row.hidden = !matches;
      if (matches) visibleCount++;
    });

    this.emptyStateTarget.hidden = visibleCount > 0;
  }

  clearFilters() {
    this.hubCompanyFilterTarget.value = "";
    this.adminFilterTarget.value = "";
    this.appEventFilterTarget.value = "";
    this.filter();
  }

  toggleSelectAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked;
    });
    this._syncBulkDeleteButton();
  }

  updateBulkDelete() {
    this._syncBulkDeleteButton();
  }

  bulkDelete() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    if (checked.length === 0) return;

    const msg = this.bulkDeleteConfirmValue.replace("%{count}", checked.length);
    if (!confirm(msg)) return;

    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.bulkDeleteUrlValue;

    const csrf = document.querySelector('meta[name="csrf-token"]');
    if (csrf) {
      const csrfInput = document.createElement("input");
      csrfInput.type = "hidden";
      csrfInput.name = "authenticity_token";
      csrfInput.value = csrf.getAttribute("content");
      form.appendChild(csrfInput);
    }

    const methodInput = document.createElement("input");
    methodInput.type = "hidden";
    methodInput.name = "_method";
    methodInput.value = "delete";
    form.appendChild(methodInput);

    checked.forEach((cb) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = "hub_staff_contact_ids[]";
      input.value = cb.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  _syncBulkDeleteButton() {
    const total = this.checkboxTargets.length;
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;

    this.bulkDeleteBtnTarget.disabled = checkedCount === 0;
    this.selectAllTarget.checked = total > 0 && checkedCount === total;
    this.selectAllTarget.indeterminate =
      checkedCount > 0 && checkedCount < total;
  }
};

StaffContactsFilterController.targets = [
  "row",
  "hubCompanyFilter",
  "adminFilter",
  "appEventFilter",
  "emptyState",
  "checkbox",
  "selectAll",
  "bulkDeleteBtn",
];
StaffContactsFilterController.values = {
  bulkDeleteUrl: String,
  bulkDeleteConfirm: String,
};

export default StaffContactsFilterController;
